import { render } from "./OrderHistoryListItem.vue?vue&type=template&id=0a04a62f"
import script from "./OrderHistoryListItem.vue?vue&type=script&lang=js"
export * from "./OrderHistoryListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__